import { classifyError } from 'src/modules/error-helper';
import type { ReduxInjections } from 'src/types';
import { GetSuggestionsDocument } from 'src/types/graphql';

import { shouldUpdate } from '../../../middlewares/utils.ts';

import {
  updateSuggestionsSuccess,
  updateSuggestionsFailure,
} from './actionCreators';

export const makeSuggestionsUpdater = ({
  api: { queryGql, apolloClient },
  appConfig,
}: ReduxInjections) => ({
  on: (type: string) => shouldUpdate(type, appConfig, apolloClient),
  run: () => {
    const { language: languageCode, zone } = appConfig;
    return queryGql({
      query: GetSuggestionsDocument,
      variables: {
        zone,
        languageCode,
      },
      fetchPolicy: 'network-only',
    });
  },
  success: updateSuggestionsSuccess,
  failure: updateSuggestionsFailure,
  classifyError,
});
